export const PHYSICAL_HAZARDS = [
  'Severe Weather',
  'On-Water Response',
  'Flooding',
  'Heat',
  'Ice/Winter Conditions',
  'Debris in Water',
] as const;
export type PhysicalHazard = (typeof PHYSICAL_HAZARDS)[number];
export const ENVIRONMENTAL_HAZARDS = [
  'Oil/Petroleum Products',
  'Flammable Gas',
  'Radiological',
  'Poison/Toxins',
  'Blood-Borne Pathogens',
  'Biological Disease',
  'Hazardous Materials',
  'Explosives',
  'Human Remains',
  'Nuclear',
  'Fire',
] as const;
export type EnvironmentalHazard = (typeof ENVIRONMENTAL_HAZARDS)[number];
export const OTHER_HAZARDS = [
  'Terrorism',
  'Civil Disturbance',
  'Traumatic Incident Stress',
  'Criminal Violence',
  'Wildlife Encounters',
] as const;
export type OtherHazard = (typeof OTHER_HAZARDS)[number];
export const REQUIRED_PPE = [
  'Life Jackets',
  'Gloves',
  'Respirators',
  'Steel Toed Boots',
  'Masks',
  'Face Shields',
  'Hard Hat',
  'Hearing Protection',
  'Fall-Protection Gear',
  'Eye Protection',
  'Protective Clothing',
  'Gas Detectors',
] as const;
export type RequiredPPE = (typeof REQUIRED_PPE)[number];
export const HAZMAT_CLASSIFICATION = [
  'Oil/Petroleum Products',
  'Flammable Solid',
  'Poison Inhalation Hazard',
  'Flammable Liquid',
  'Flammable Gas',
  'Radioactive',
  'Explosives',
  'Oxidizer',
  'Corrosive',
  'Gases',
  'Poison (Toxic)',
  'Dangerous When Wet',
  'Other/Miscellaneous',
] as const;
export type HAZMATClassification = (typeof HAZMAT_CLASSIFICATION)[number];
export const POTENTIAL_HAZARDS = [
  'The atmosphere contains no known hazards and work conditions preclude splashes, immersion, or potential for unexpected inhalation contact with hazardous levels of any chemicals or pollutants.',
  'Concentrations or types of airborne substances are known and the criteria for using air purifying respirators are met.',
  'Highest level of respiratory protection is needed, but lesser level of skin protection is needed. (SCBA)',
  'Greatest level of skin, respiratory, and eye protection is needed. (Level A)',
] as const;
export type PotentialHazard = (typeof POTENTIAL_HAZARDS)[number];
export const INCIDENT_NEEDS = [
  'Security Perimeter',
  'Evacuation Procedures',
  'Medical Triage',
  'Safety Zone',
  'Warning/Danger Signs',
  'Safety Briefings for Responders',
] as const;
export type IncidentNeed = (typeof INCIDENT_NEEDS)[number];
type OptionType<T> = {
  label: T;
  value: T;
};
export type PhysicalHazardOption = OptionType<PhysicalHazard>;
export type EnvironmentalHazardOption = OptionType<EnvironmentalHazard>;
export type OtherHazardOption = OptionType<OtherHazard>;
export type RequiredPPEOption = OptionType<RequiredPPE>;
export type HazmatOption = OptionType<HAZMATClassification>;
export type PotentialHazardOption = OptionType<PotentialHazard>;
export type IncidentNeedOption = OptionType<IncidentNeed>;
